import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  useLocation,
  useNavigate,
  useRoutes,
} from "react-router-dom";
import AppRoute from "./config/app-route.jsx";

// bootstrap
import "bootstrap";

// css
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.css";
import "./scss/react.scss";
import { Provider } from "react-redux";
import { store } from "./_store";
import { history } from "./_helpers/history.js";
import { useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const container = document.getElementById("root");
const root = createRoot(container);
function App() {
  const location = useLocation();
  const pathList = location?.pathname.split("/");

  useEffect(() => {
    if (pathList.includes("Admin")) {
      import("./assets/css/AdminStyle.css");
    } else {
      import("./assets/css/userStyle.css");
      import("sal.js/dist/sal.css");

      // Dynamically import sal.js and initialize
      import("sal.js").then((salModule) => {
        salModule.default();
      });
    }
  }, [pathList]);

  history.navigate = useNavigate();
  history.location = useLocation();

  let element = useRoutes(AppRoute);
  return element;
}

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* <App /> */}
  </Provider>
);
